import { Link } from "react-router-dom";
import { Instagram, Podcast, Mail, ArrowUpRight } from "lucide-react";
import { LINKS, NAV_LINKS } from "@/data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white grain">
    <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-16 md:py-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/images/tsm-logo-white.png"
            alt="The Strength Movement, Strength through Science and Psychology"
            className="h-14 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
            We don't just build stronger lifters. We build women who trust
            themselves, through strength, food freedom and education.
          </p>
          <div className="mt-6 flex gap-3">
            <a
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram"
              className="rounded-full border border-white/20 p-2.5 transition-colors duration-300 hover:border-ocean hover:text-ocean"
            >
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a
              href={LINKS.podcast}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-podcast-link"
              aria-label="Podcast on Spotify"
              className="rounded-full border border-white/20 p-2.5 transition-colors duration-300 hover:border-ocean hover:text-ocean"
            >
              <Podcast size={18} strokeWidth={1.5} />
            </a>
            <a
              href={LINKS.emailList}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-email-list-link"
              aria-label="Join the email list"
              className="rounded-full border border-white/20 p-2.5 transition-colors duration-300 hover:border-ocean hover:text-ocean"
            >
              <Mail size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="label-text text-white/40">Explore</p>
          <ul className="mt-5 space-y-3">
            {[{ to: "/", label: "Home" }, ...NAV_LINKS, { to: "/contact", label: "Contact" }, { to: "/privacy", label: "Privacy" }].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="label-text text-white/40">Free resources</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                href={LINKS.liftingGuide}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-lifting-guide-link"
                className="group inline-flex items-center gap-1 text-sm text-white/70 transition-colors duration-300 hover:text-white"
              >
                Max Lifting Guide
                <ArrowUpRight size={13} strokeWidth={1.5} className="opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            </li>
            <li>
              <a
                href={LINKS.foodFreedomGuide}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-food-freedom-guide-link"
                className="group inline-flex items-center gap-1 text-sm text-white/70 transition-colors duration-300 hover:text-white"
              >
                Food Freedom Guide
                <ArrowUpRight size={13} strokeWidth={1.5} className="opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            </li>
            <li>
              <a
                href={LINKS.podcast}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-podcast-text-link"
                className="group inline-flex items-center gap-1 text-sm text-white/70 transition-colors duration-300 hover:text-white"
              >
                The Strength Movement Podcast
                <ArrowUpRight size={13} strokeWidth={1.5} className="opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-2 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} The Strength Movement. All rights reserved.
        </p>
        <p>Build strength. Trust your body. Train with confidence.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
